export const LOG_IN_WITH_EMAIL_AND_PASSWORD = 'logInWithEmailAndPassword';
export const LOG_IN_WITH_EXISTING_SESSION_TOKEN = 'logInWithExistingSessionToken';
export const LOG_IN_WITH_GOOGLE_AUTH = 'logInWithGoogleAuth';
export const FETCH_LAST_LOGGED_IN_USER = 'fetchLastLoggedInUser';
export const LOG_OUT_USER = 'logOutUser';
export const CREATE_USER_WITH_EMAIL_AND_PASSWORD = 'createUserWithEmailAndPassword';
export const CREATE_USER_WITH_EMAIL_AND_PASSWORD_FROM_INVITATION = 'createUserWithEmailAndPasswordFromInvitation';
export const CONFIRM_PASSWORD_RESET = 'confirmPasswordReset';
export const SEND_PASSWORD_RESET_EMAIL = 'sendPasswordResetEmail';
export const VERIFY_PASSWORD_RESET_CODE = 'verifyPasswordResetCode';
